import storage from "@/_util/storage-methods"

export default [
    {
        name: "credentialCache",
        get: storage.getLocalStorageJson("credential-cache", { }),
        set: storage.setLocalStorageJson("credential-cache"),
    },
];
